var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/Survey/Survey.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable no-extra-parens */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import globalConfig from "../../util/globalConfig";
import scrollToTop from "../../util/scrollToTop";
import { startSurvey } from "../../network/surveyClient";
import { redirectToCompletionUrl } from "../../util/redirectToCompletionUrl";
import logForGoogleAnalytics from "../../util/logForGoogleAnalytics";
import Message from "../Message/Message";
import Page from "../Page/Page";
import Spinner from "../Spinner/Spinner";

/**
 * Renders a survey for the corresponding `surveyId`.
 * If `tokenProvider` is not specified, then an unauthenticated survey begins.
 * completionCallback is favored over completionUrl. e.g. If a callback is specified, url is ignored.
 *
 * @param {Object} params parameters to get a survey started
 * @returns {JSX.Element} JSX Element
 */
var Survey = function Survey(_ref) {
  var surveyId = _ref.surveyId,
    googleAnalyticsSurveyTrackingName = _ref.googleAnalyticsSurveyTrackingName,
    tokenProvider = _ref.tokenProvider,
    _ref$customErrorMessa = _ref.customErrorMessage,
    customErrorMessage = _ref$customErrorMessa === void 0 ? null : _ref$customErrorMessa,
    _ref$customLoadingMes = _ref.customLoadingMessage,
    customLoadingMessage = _ref$customLoadingMes === void 0 ? null : _ref$customLoadingMes,
    _ref$completionUrl = _ref.completionUrl,
    completionUrl = _ref$completionUrl === void 0 ? null : _ref$completionUrl,
    _ref$completionCallba = _ref.completionCallback,
    completionCallback = _ref$completionCallba === void 0 ? null : _ref$completionCallba;
  var unauthenticated = !tokenProvider;
  if (tokenProvider && typeof globalConfig.get("tokenProvider") !== "function") {
    globalConfig.set({
      tokenProvider: tokenProvider
    });
  }
  var DEFAULT_ERROR_MESSAGE = "Something went wrong on our end.";
  var DEFAULT_LOADING_MESSAGE = "Loading…";
  var ERROR_MESSAGE = customErrorMessage ? customErrorMessage : DEFAULT_ERROR_MESSAGE;
  var LOADING_MESSAGE = customLoadingMessage ? customLoadingMessage : DEFAULT_LOADING_MESSAGE;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasError = _useState4[0],
    setHasError = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var setupGoogleAnalyticsFormTrackingEvents = function setupGoogleAnalyticsFormTrackingEvents() {
    return document.dispatchEvent(new CustomEvent("formUpdate"));
  };
  var initializeGoogleAnalyticsFormTrackingEvents = function initializeGoogleAnalyticsFormTrackingEvents(userResponseId) {
    logForGoogleAnalytics({
      referenceId: userResponseId
    });
    setupGoogleAnalyticsFormTrackingEvents();
  };
  var onComplete = function onComplete(responseData) {
    if (typeof completionCallback === "function") {
      completionCallback(responseData);
    } else if (completionUrl) {
      redirectToCompletionUrl(completionUrl);
    }
  };
  var onFormSubmit = function onFormSubmit(responseData) {
    if (responseData.complete) {
      onComplete(responseData);
      // Return so the screen doesn't flash after the url.
      return;
    }
    setData(responseData);
    setupGoogleAnalyticsFormTrackingEvents();
    scrollToTop();
  };

  /**
   * @param {string} message Contains a message to display to the user
   * @param {object} optionalImage JSX formatted object
   * @returns {object} JSX formatted markup
   */
  var displayMessage = function displayMessage(message) {
    var optionalImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return /*#__PURE__*/React.createElement("div", {
      className: "survey-Survey",
      "data-testid": "Survey",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "survey-Survey-content",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Message, {
      message: message,
      optionalImage: optionalImage,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 9
      }
    })));
  };
  useEffect(function () {
    startSurvey(surveyId, unauthenticated).then(function (initialSurveyData) {
      setData(initialSurveyData);
      setIsLoading(false);
      initializeGoogleAnalyticsFormTrackingEvents(initialSurveyData.user_response_id);
    })["catch"](function () {
      setHasError(true);
      setIsLoading(false);
    });
  }, [surveyId, unauthenticated]);
  if (isLoading) {
    return displayMessage(LOADING_MESSAGE, /*#__PURE__*/React.createElement(Spinner, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 110,
        columnNumber: 44
      }
    }));
  }
  if (hasError) {
    return displayMessage(ERROR_MESSAGE);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "survey-Survey",
    "data-testid": "Survey",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "survey-Survey-content",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Page, {
    googleAnalyticsSurveyTrackingName: googleAnalyticsSurveyTrackingName,
    surveyPage: data,
    onSubmit: onFormSubmit,
    unauthenticated: unauthenticated,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 9
    }
  })));
};
Survey.propTypes = {
  surveyId: PropTypes.string.isRequired,
  googleAnalyticsSurveyTrackingName: PropTypes.string.isRequired,
  tokenProvider: PropTypes.func,
  customErrorMessage: PropTypes.string,
  customLoadingMessage: PropTypes.string,
  completionUrl: PropTypes.string,
  completionCallback: PropTypes.func
};
export default Survey;